export const RU_TARGET_COLUMNS = [
  {
    key: "headerName",
    label: "Header Name",
    field: "headerName",
    minWidth: 160,
    align: "left",
  },
  {
    key: "fdate",
    label: "Detail From Date",
    field: "fdate",
    minWidth: 140,
    align: "center",
  },
  {
    key: "tdate",
    label: "Detail To Date",
    field: "tdate",
    minWidth: 140,
    align: "center",
  },
  {
    key: "rqty",
    label: "Detail Ru Factor",
    field: "rqty",
    minWidth: 120,
    align: "right",
  },
  {
    key: "rvalue",
    label: "Detail Ru Value",
    field: "rvalue",
    minWidth: 130,
    align: "right",
  },
  {
    key: "employeeCode",
    label: "Assign Sales Team Emp Code",
    field: "employeeCode",
    minWidth: 220,
    align: "center",
  },
  {
    key: "errorMessage",
    label: "Error Message",
    field: "errorMessage",
    minWidth: 220,
    align: "left",
    isError: true,
  },
];
